
import GetActiveClientAPI from "./GetActiveClientAPI";
const GetActiveClientService = async (): Promise<any> => {
 try {
    const res = await GetActiveClientAPI()
      return res;
 } catch (error) {
    throw error;
 }
};
export default GetActiveClientService;
